/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable no-use-before-define */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
import React, { useRef, useState, useEffect } from 'react';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Selection,
  Inject,
  Edit,
  Toolbar,
  Freeze,
  ForeignKey,
  Resize,
  Sort,
  Filter,
  ColumnChooser,
  ExcelExport,
  Search,
} from '@syncfusion/ej2-react-grids';
import { Link, useNavigate } from 'react-router-dom';
import { DialogComponent, DialogUtility } from '@syncfusion/ej2-react-popups';
import { DropDownListComponent, MultiSelectComponent, CheckBoxSelection } from '@syncfusion/ej2-react-dropdowns';
import { useStateContext } from '../contexts/ContextProvider';
import scribeHow from '../data/scribehow.png';

import billing from '../data/billingbkg.png';
import inventory from '../data/inventorybkg.png';

import reports from '../data/reportsbkg.png';
import calendar from '../data/calendarbkg.png';
import alerts from '../data/alerts_orange.png';
import notifications from '../data/notifications.png';
import dashboard from '../data/dashboardbkg.png';
import associate from '../data/associatesbkg.png';
import namepng from '../data/nameicon.png';
import user3 from '../data/users3.png';
import orgorange from '../data/org_orange.png';
import gear from '../data/gear.png';
import './Zackat.css';
import { Header } from '../components';

const Roles = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=roles');
    return <p>Please login... </p>;
  }
  const {
    zRenderMode,
    boss,
    screenSize,
    isMobile,
  } = useStateContext();

  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const clone = { text: 'Clone', tooltipText: 'Clone Role', prefixIcon: 'e-copy', id: 'clone', disabled: false };
  const add = { text: 'Add', tooltipText: 'Add Role', prefixIcon: 'e-add', id: 'add', disabled: false };
  const edit = { text: 'Edit', tooltipText: 'Edit Role', prefixIcon: 'e-edit', id: 'edit', disabled: false };
  const del = { text: 'Delete', tooltipText: 'Delete Role', prefixIcon: 'e-delete-2', id: 'delete', disabled: false };
  const excel = { text: 'Excel Export', tooltipText: 'Export', prefixIcon: 'e-export-excel', id: 'excel', disabled: false };
  let roleSelected;
  const toolbarOptions = [add, edit, clone, del, excel];
  const { REACT_APP_API_ENDPOINT } = process.env;
  const rowClicked = (args) => {
    roleSelected = args.rowIndex;
  };
  const updateRole = (e) => {
    switch (e.element.id) {
      case 'billing.permissions':
        data.roles[roleSelected].billing.permissions = e.value;
        break;
      case 'reports.permissions':
        data.roles[roleSelected].reports.permissions = e.value;
        break;
      case 'dashboard.permissions':
        data.roles[roleSelected].dashboard.permissions = e.value;
        break;
      case 'users.permissions':
        data.roles[roleSelected].users.permissions = e.value;
        break;
      case 'alerts.permissions':
        data.roles[roleSelected].alerts.permissions = e.value;
        break;
      case 'calendar.permissions':
        data.roles[roleSelected].calendar.permissions = e.value;
        break;
      case 'notifications.permissions':
        data.roles[roleSelected].notifications.permissions = e.value;
        break;
      case 'organizations.permissions':
        data.roles[roleSelected].organizations.permissions = e.value;
        break;
      case 'associates.permissions':
        data.roles[roleSelected].associates.permissions = e.value;
        break;
      case 'inventory.permissions':
        data.roles[roleSelected].inventory.permissions = e.value;
        break;
      case 'roles.permissions':
        data.roles[roleSelected].roles.permissions = e.value;
        break;
      default:
        dialogClick('na', 'Role Action', 'Invalid Role selected', null);
        return;
    }
    fetch(`${REACT_APP_API_ENDPOINT}/roles`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(data.roles[roleSelected]),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        //  The added/edited data will be saved in the Grid
        // dialogClick('na', 'Update Role', responseJson.response, null);
        setReload(!reload);
      })
      .catch((error) => {
        dialogClick('na', 'Update Role Action', error, null);
      });
  };
  const typeGrid = (props) => (
    <div>
      <DropDownListComponent
        id="device"
        dataSource={items}
        fields={{ value: 'id', text: 'name' }}
        value={props.systemType}
      />
    </div>
  );
  const handleTypeChange = (args) => {
    if (args && args.itemData) {
      data.roles.forEach((a, index) => {
        if (a._id === args.element.id) {
          data.roles[index].systemType = args.value;
          fetch(`${REACT_APP_API_ENDPOINT}/roles`, {
            method: 'UPDATE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
            body: JSON.stringify(data.roles[index]),
          })
            .then((response) => response.json())
            .then((responseJson) => {
              // The added/edited data will be saved in the Grid
              if (responseJson && responseJson.response && responseJson.response !== 'OK') {
                dialogClick('na', 'Role Action', 'An error has occured during Update!', null);
              } else {
                dialogClick('na', 'Role Action', 'Updated!', null);
                setReload(!reload);
              }
            })
            .catch((error) => {
              dialogClick('na', 'Role Action', 'error!', null);
            });
        }
      });
    }
  };
  const typeTemplateGrid = (props) => (
    <div>
      <DropDownListComponent
        id={props._id}
        dataSource={items}
        fields={{ value: 'id', text: 'name' }}
        value={props.systemType}
        change={handleTypeChange}
        placeholder="Select Role Type"
      />
    </div>
  );

  const roleTemplateGrid = (props) => {
    let dtsource = multiselectDatasource;
    let value = null;
    switch (props.column.field) {
      case 'billing.permissions':
        value = props.billing.permissions;
        break;
      case 'reports.permissions':
        value = props.reports.permissions;
        break;
      case 'dashboard.permissions':
        value = props.dashboard.permissions;
        break;
      case 'users.permissions':
        value = props.users.permissions;
        break;
      case 'alerts.permissions':
        value = props.alerts.permissions;
        break;
      case 'calendar.permissions':
        value = props.calendar.permissions;
        break;
      case 'notifications.permissions':
        value = props.notifications.permissions;
        break;
      case 'organizations.permissions':
        value = props.organizations.permissions;
        dtsource = orgmultiselectDatasource;
        break;
      case 'associates.permissions':
        value = props.associates.permissions;
        dtsource = assocmultiselectDatasource;
        break;
      case 'inventory.permissions':
        value = props.inventory.permissions;
        dtsource = invmultiselectDatasource;
        break;
      case 'roles.permissions':
        value = props.roles.permissions;
        dtsource = rolesmultiselectDatasource;
        break;
      default:
        break;
    }
    return (
      <div>
        <MultiSelectComponent
          id={props.column.foreignKeyField}
          dataSource={dtsource}
          mode="CheckBox"
          fields={{ value: 'value', text: 'text' }}
          value={value}
          change={(e) => { updateRole(e); }}
          placeholder="Select Permissions(s)"
        >
          <Inject services={[CheckBoxSelection]} />
        </MultiSelectComponent>
      </div>
    );
  };
  const grid = useRef(null);
  const dialogRef = useRef(null);
  const dataBound = (args) => {
    if (grid && grid.current) {
      grid.current.toolbarModule.toolbar.overflowMode = 'MultiRow';
    }
  };
  const selectionSettings = {
    type: 'Single', // Allows only single row selection
  };

  const [reload, setReload] = useState(true);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortOptions, setSortColumns] = useState({});
  const [items, setItems] = useState([
    { id: 1, name: 'User' },
    { id: 2, name: 'System' },
  ]);
  const result = items.find((i) => i.id === 3);
  if (boss && !result) {
    items.push(
      { id: 3, name: 'Reserved' },
    );
  }

  const dialogButtons = [{
    click: () => {
      dialogRef.current.hide();
    },
    buttonModel: { content: 'OK', isPrimary: true },
  }];
  useEffect(() => {
    if (boss) {
      const newitems = [
        { id: 1, name: 'User' },
        { id: 2, name: 'System' },
        { id: 3, name: 'Reserved' },
      ];
      setItems(newitems);
    } else {
      const newitems = [
        { id: 1, name: 'User' },
        { id: 2, name: 'System' },
      ];
      setItems(newitems);
    }
  }, [boss]);
  useEffect(() => {
    setLoading(true);
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/roles?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();
      if (mydata && mydata.user && mydata.user.preferences && mydata.user.preferences.roles.sort && mydata.user.preferences.roles.sort[0].direction) {
        const mysortedColumns = { columns: mydata.user.preferences.roles.sort };
        setSortColumns(mysortedColumns);
      }

      // set state when the data received
      setData(mydata);
      setLoading(false);
    };
    dataFetch();
  }, [reload]);
  let dialogInstance;

  function dialogOK(f, element) {
    dialogInstance.hide();
  }
  function dialogClick(f, hdr, content, element) {
    let ok = null;
    if (f !== 'na') {
      ok = { text: 'OK', click: () => { dialogOK(f, element); } };
      if (grid && grid.current) {
        const selectedRow = grid.current.getSelectedRecords()[0];
        if (!selectedRow) {
          dialogClick('na', 'Inventory Row', 'No device selected', null);
          return;
        }
      }
    }
    dialogInstance = DialogUtility.confirm({
      title: hdr,
      content,
      okButton: ok,
      cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
      showCloseIcon: true,
      closeOnEscape: true,
      isModal: true,
      animationSettings: { effect: 'Zoom' },
    });
  }

  const clickHandler = (args) => {
    if (!grid || !grid.current) {
      return;
    }
    if (grid && grid.current && args.item.properties.text === 'Clone') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (selectedRecords.length !== 1) {
        // DialogUtility.alert('Please select a row!');
        dialogRef.current.show(); // Show dialog if no row is selected
        args.cancel = true;
        return;
      }
      const message = prompt(`Enter a new name for the Clone of Role ${selectedRecords[0].name}.`, '');
      if (!message || message.length === 0) {
        return;
      }
      for (let x = 0; x < data.roles.length; x += 1) {
        if (message === data.roles[x].name) {
          DialogUtility.alert(`This name ${data.roles[x].name} is already used, please select a unique name`);
          return;
        }
      }
      if (message === selectedRecords[0].name) {
        DialogUtility.alert('Please do not use the same name!!');
        return;
      }
      if (message && message.length > 0) {
        const newrole = {
          reports: selectedRecords[0].reports,
          roles: selectedRecords[0].roles,
          organizations: selectedRecords[0].organizations,
          users: selectedRecords[0].users,
          associates: selectedRecords[0].associates,
          billing: selectedRecords[0].billing,
          notifications: selectedRecords[0].notifications,
          inventory: selectedRecords[0].inventory,
          calendar: selectedRecords[0].calendar,
          alerts: selectedRecords[0].alerts,
          dashboard: selectedRecords[0].dashboard,
        };
        newrole.name = message;
        newrole._id = '';
        newrole.organizationid = selectedRecords[0].organizationid;
        fetch(`${REACT_APP_API_ENDPOINT}/roles`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(newrole),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            if (!responseJson || !responseJson._id || responseJson._id.length === 0) {
              DialogUtility.alert('Role add failed');
              args.cancel = true;
              return;
            }
            dialogClick('na', 'Insert Clone', responseJson.response, null);
            setReload(!reload);
          })
          .catch(() => {
            dialogClick('na', 'Insert Clone', 'An error has occured during Invitation request!', null);
            args.cancel = true;
          });
      }
    } else if (grid && grid.current && args.item.properties.text === 'Add') {
      grid.current.addRecord();
    } else if (grid && args.item.properties.text === 'Delete') {
      const selectedRecords = grid.current.getSelectedRecords();
      const selectedRow = selectedRecords[0];
      grid.current.deleteRecord(selectedRow);
    } else if (grid && grid.current && args.item.properties.text === 'Edit') {
      const selectedRecords = grid.current.getSelectedRecords();
      grid.current.startEdit(selectedRecords[0]);
    } else if (grid && grid.current && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `Roles${new Date().toISOString()}.xlsx`,
      };
      grid.current.excelExport(properties);
    }
  };
  const actionBegin = (args) => {
    if (args.requestType === 'sorting') {
      setUserPreferences('sort', [{ field: args.columnName, direction: args.direction }]);
    }
  };
  const actionComplete = (args) => {
    const editedData = args.data;
    if (grid && args.requestType === 'beginEdit') {
      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      if (dialog) {
        dialog.header = `Details of ${args.rowData.name}`;
        dialog.width = '50vw';
      }
    }
    /** Set initial Focus */
    if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (args.data) {
        if (reportsRef && reportsRef.value) {
          editedData.reports.permissions = reportsRef.value;
        }
        if (rolesRef && rolesRef.value) {
          editedData.roles.permissions = rolesRef.value;
        }
        if (organizationsRef && organizationsRef.value) {
          editedData.organizations.permissions = organizationsRef.value;
        }
        if (usersRef && usersRef.value) {
          editedData.users.permissions = usersRef.value;
        }
        if (associatesRef && associatesRef.value) {
          editedData.associates.permissions = associatesRef.value;
        }
        if (billingRef && billingRef.value) {
          editedData.billing.permissions = billingRef.value;
        }
        if (notificationsRef && notificationsRef.value) {
          editedData.notifications.permissions = notificationsRef.value;
        }
        if (inventoryRef && inventoryRef.value) {
          editedData.inventory.permissions = inventoryRef.value;
        }
        if (calendarRef && calendarRef.value) {
          editedData.calendar.permissions = calendarRef.value;
        }
        if (alertsRef && alertsRef.value) {
          editedData.alerts.permissions = alertsRef.value;
        }
        if (dashboardRef && dashboardRef.value) {
          editedData.dashboard.permissions = dashboardRef.value;
        }
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/roles`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            if (!responseJson || !responseJson._id || responseJson._id.length === 0) {
              DialogUtility.alert('Role add failed');
              args.cancel = true;
              return;
            }
            if (responseJson && responseJson._id) {
              args.data._id = responseJson._id;
            }
            dialogClick('na', 'Insert Role', editedData.name, null);
            setReload(!reload);
          })
          .catch((error) => {
            dialogClick('na', 'Insert Role error', error, null);
            args.cancel = true;
          });
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      if (args.data) {
        if (args.data) {
          editedData.reports.permissions = reportsRef.value;
          editedData.roles.permissions = rolesRef.value;
          editedData.organizations.permissions = organizationsRef.value;
          editedData.users.permissions = usersRef.value;
          editedData.associates.permissions = associatesRef.value;
          editedData.billing.permissions = billingRef.value;
          editedData.notifications.permissions = notificationsRef.value;
          editedData.inventory.permissions = inventoryRef.value;
          editedData.calendar.permissions = calendarRef.value;
          editedData.alerts.permissions = alertsRef.value;
          editedData.dashboard.permissions = dashboardRef.value;
          // The default edit operation is cancelled
          // Here you can send the updated data to your server using AJAX call
          fetch(`${REACT_APP_API_ENDPOINT}/roles`, {
            method: 'UPDATE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
            body: JSON.stringify(editedData),
          })
            .then((response) => response.json())
            .then((responseJson) => {
              //  The added/edited data will be saved in the Grid
              dialogClick('na', 'Update Role', responseJson.response, null);
              setReload(!reload);
            })
            .catch((error) => {
              dialogClick('na', 'Update Role error', error, null);
              args.cancel = true;
            });
        }
      }
    } else if (args.requestType === 'delete') {
      if (args.data) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/roles`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              args.cancel = true;
            }
            dialogClick('na', 'Delete Role', responseJson.response, null);
            // The added/edited data will be saved in the Grid
            setReload(!reload);
          })
          .catch((error) => {
            dialogClick('na', 'Delete Role error', error, null);
            args.cancel = true;
          });
      }
    }
  };
  function setUserPreferences(pref, val) {
    if (!data.user.preferences) {
      data.user.preferences = {};
    }
    if (!data.user.preferences.roles) {
      data.user.preferences.roles = {};
    }
    if (pref === 'group') {
      data.user.preferences.roles = { group: val, sort: data.user.preferences.roles.sort };
    } else if (pref === 'sort') {
      data.user.preferences.roles = { group: data.user.preferences.roles.group, sort: val };
    }
    // Remove the New Password to avoid creating a new password
    data.user.newPassword = '';
    // Avoid Password comparison
    data.user.password = '';
    if (data.user.lastLogin && data.user.lastLogin === '') {
      data.user.lastLogin = '1970-01-01T00:00:00.000Z';
    }
    fetch(`${REACT_APP_API_ENDPOINT}/user`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(data.user),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          DialogUtility.alert(responseJson.response);
        }
      })
      .catch(() => {
      });
  }

  if (loading) {
    return <p>Loading... </p>;
  }
  let notificationsRef; let reportsRef; let usersRef; let organizationsRef; let associatesRef; let billingRef; let inventoryRef; let rolesRef; let
    calendarRef; let alertsRef; let dashboardRef;

  let crudUpdate = false;
  let crudCreate = false;
  let crudDelete = false;
  if (data.role.roles.permissions.includes('Create')) {
    crudCreate = true;
  }
  if (data.role.roles.permissions.includes('Update')) {
    crudUpdate = true;
  }
  if (data.role.roles.permissions.includes('Delete')) {
    crudDelete = true;
  }
  if (!data.role.roles.permissions.includes('Read')) {
    return <p>Not authorized...</p>;
  }
  const multiselectDatasource = [
    { value: 'Create', text: 'Create' },
    { value: 'Read', text: 'Read' },
    { value: 'Update', text: 'Update' },
    { value: 'Delete', text: 'Delete' },
    { value: 'Import', text: 'Import' },
  ];
  const appmultiselectDatasource = [
    { value: 'Create', text: 'Create' },
    { value: 'Read', text: 'Read' },
    { value: 'Update', text: 'Update' },
    { value: 'Delete', text: 'Delete' },
    { value: 'Calliope', text: 'Calliope' },
    { value: 'Import', text: 'Import' },
  ];
  const orgmultiselectDatasource = [
    { value: 'Create', text: 'Create' },
    { value: 'Read', text: 'Read' },
    { value: 'Update', text: 'Update' },
    { value: 'Delete', text: 'Delete' },
    { value: 'Recordings', text: 'Recordings' },
    { value: 'OTA', text: 'OTA' },
    { value: 'Jobs', text: 'Jobs' },
    { value: 'Tasks', text: 'Tasks' },
    { value: 'Onboarding', text: 'Onboarding' },
    { value: 'Templates', text: 'Templates' },
    { value: 'Billing', text: 'Billing' },
    { value: 'Import', text: 'Import' },
  ];
  const rolesmultiselectDatasource = [
    { value: 'Create', text: 'Create' },
    { value: 'Read', text: 'Read' },
    { value: 'Update', text: 'Update' },
    { value: 'Delete', text: 'Delete' },
    { value: 'Boss', text: 'Boss' },
    { value: 'Development', text: 'Development' },
  ];
  const invmultiselectDatasource = [
    { value: 'Create', text: 'Create' },
    { value: 'Read', text: 'Read' },
    { value: 'Update', text: 'Update' },
    { value: 'Delete', text: 'Delete' },
    { value: 'Card', text: 'Card' },
    { value: 'Individual', text: 'Individual' },
    { value: 'Abbreviated', text: 'Abbreviated' },
    { value: 'All', text: 'All' },
    { value: 'Events', text: 'Events' },
    { value: 'Raw Events', text: 'Raw Events' },
    { value: 'Import', text: 'Import' },
  ];
  const assocmultiselectDatasource = [
    { value: 'Create', text: 'Create' },
    { value: 'Read', text: 'Read' },
    { value: 'Update', text: 'Update' },
    { value: 'Delete', text: 'Delete' },
    { value: 'Triage', text: 'Triage' },
    { value: 'Individual', text: 'Individual' },
    { value: 'Abbreviated', text: 'Abbreviated' },
    { value: 'Invite', text: 'Invite' },
    { value: 'All', text: 'All' },
    { value: 'Manager', text: 'Manager' },
    { value: 'Managers', text: 'Managers' },
    { value: 'Events', text: 'Events' },
    { value: 'Biometrics', text: 'Biometrics' },
    { value: 'SMS', text: 'SMS' },
    { value: 'Recordings', text: 'Recordings' },
    { value: 'SST', text: 'SST' },
    { value: 'Duress', text: 'Duress' },
    { value: 'Import', text: 'Import' },
  ];

  const fields = { value: 'value', text: 'text' };
  const rolesOrganizationsGridCrud = (props) => (
    <div>
      <label>Organizations</label>
      <MultiSelectComponent id="organizations.permissions" ref={(scope) => { organizationsRef = scope; }} mode="CheckBox" dataSource={orgmultiselectDatasource} fields={fields} value={props.organizations.permissions}>
        <Inject services={[CheckBoxSelection]} />
      </MultiSelectComponent>
    </div>
  );
  const rolesUsersGridCrud = (props) => (
    <div>
      <label>Users</label>
      <MultiSelectComponent id="users.permissions" ref={(scope) => { usersRef = scope; }} mode="CheckBox" dataSource={multiselectDatasource} fields={fields} value={props.users.permissions}>
        <Inject services={[CheckBoxSelection]} />
      </MultiSelectComponent>
    </div>
  );
  const rolesNotificationsGridCrud = (props) => (
    <div>
      <label>Notifications</label>
      <MultiSelectComponent id="notifications.permissions" ref={(scope) => { notificationsRef = scope; }} mode="CheckBox" dataSource={multiselectDatasource} fields={fields} value={props.notifications.permissions}>
        <Inject services={[CheckBoxSelection]} />
      </MultiSelectComponent>
    </div>
  );
  const rolesAssociatesGridCrud = (props) => (
    <div>
      <label>Associates</label>
      <MultiSelectComponent id="associates.permissions" ref={(scope) => { associatesRef = scope; }} mode="CheckBox" dataSource={assocmultiselectDatasource} fields={fields} closePopupOnSelect value={props.associates.permissions}>
        <Inject services={[CheckBoxSelection]} />
      </MultiSelectComponent>
    </div>
  );
  const rolesInventoryGridCrud = (props) => (
    <div>
      <label>Inventory</label>
      <MultiSelectComponent id="inventory.permissions" ref={(scope) => { inventoryRef = scope; }} mode="CheckBox" dataSource={invmultiselectDatasource} fields={fields} value={props.inventory.permissions}>
        <Inject services={[CheckBoxSelection]} />
      </MultiSelectComponent>
    </div>
  );
  const rolesCalendarGridCrud = (props) => (
    <div>
      <label>Calendar/Apps</label>
      <MultiSelectComponent id="calendar.permissions" ref={(scope) => { calendarRef = scope; }} mode="CheckBox" dataSource={appmultiselectDatasource} fields={fields} value={props.calendar.permissions}>
        <Inject services={[CheckBoxSelection]} />
      </MultiSelectComponent>
    </div>
  );
  const rolesBillingGridCrud = (props) => (
    <div>
      <label>Billing</label>
      <MultiSelectComponent id="billing.permissions" ref={(scope) => { billingRef = scope; }} mode="CheckBox" dataSource={multiselectDatasource} fields={fields} value={props.billing.permissions}>
        <Inject services={[CheckBoxSelection]} />
      </MultiSelectComponent>
    </div>
  );
  const rolesRolesGridCrud = (props) => (
    <div>
      <label>Roles</label>
      <MultiSelectComponent id="roles.permissions" ref={(scope) => { rolesRef = scope; }} mode="CheckBox" dataSource={rolesmultiselectDatasource} fields={fields} value={props.roles.permissions}>
        <Inject services={[CheckBoxSelection]} />
      </MultiSelectComponent>
    </div>
  );
  const rolesReportsGridCrud = (props) => (
    <div>
      <label>Reports</label>
      <MultiSelectComponent id="reports.permissions" ref={(scope) => { reportsRef = scope; }} mode="CheckBox" dataSource={multiselectDatasource} fields={fields} value={props.reports.permissions}>
        <Inject services={[CheckBoxSelection]} />
      </MultiSelectComponent>
    </div>
  );
  const rolesAlertsGridCrud = (props) => (
    <div>
      <label>Alerts</label>
      <MultiSelectComponent id="alerts.permissions" ref={(scope) => { alertsRef = scope; }} mode="CheckBox" dataSource={multiselectDatasource} fields={fields} value={props.alerts.permissions}>
        <Inject services={[CheckBoxSelection]} />
      </MultiSelectComponent>
    </div>
  );
  const rolesDashboardGridCrud = (props) => (
    <div>
      <label>Dashboard</label>
      <MultiSelectComponent id="dashboard.permissions" ref={(scope) => { dashboardRef = scope; }} mode="CheckBox" dataSource={multiselectDatasource} fields={fields} value={props.dashboard.permissions}>
        <Inject services={[CheckBoxSelection]} />
      </MultiSelectComponent>
    </div>
  );
  const gridNameHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={namepng}
        alt="name"
      />
      <pre>Name</pre>
    </div>
  );
  const gridBillingHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={billing}
        alt="billing"
      />
      <pre>Billing</pre>
    </div>
  );
  const gridReportsHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={reports}
        alt="reports"
      />
      <pre>Reports</pre>
    </div>
  );
  const gridOrgHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={orgorange}
        alt="building"
      />
      <pre>Organizations</pre>
    </div>
  );
  const gridInventoryHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={inventory}
        alt="inventory"
      />
      <pre>Inventory</pre>
    </div>
  );
  const gridCalendarHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={calendar}
        alt="calendar"
      />
      <pre>Calendar/Apps</pre>
    </div>
  );
  const gridDashboardHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={dashboard}
        alt="dashboard"
      />
      <pre>Dashboard</pre>
    </div>
  );
  const gridAlertsHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={alerts}
        alt="alerts"
      />
      <pre>Alerts</pre>
    </div>
  );
  const gridNotificationsHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={notifications}
        alt="notifications"
      />
      <pre>Notifications</pre>
    </div>
  );
  const gridUsersHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={user3}
        alt="users"
      />
      <pre>Users</pre>
    </div>
  );
  const gridAssociatesHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={associate}
        alt="associates"
      />
      <pre>Associates</pre>
    </div>
  );
  const gridRolesHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={gear}
        alt="roles"
      />
      <pre>Roles</pre>
    </div>
  );
  const editing = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    mode: 'Dialog',
  };
  const editingMobile = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    mode: 'Normal',
  };

  const valuerules = { required: true };

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl zackat-div">
      <div className="flex">
        <Link
          className="my-link"
          to="https://scribehow.com/viewer/Editing_a_Role_in_the_Application__0J_pPPQ4T5eo7XzMTzd_Eg"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
        <Header category="Administration" title="Roles" />
      </div>
      <div className="e-adaptive-demo e-bigger ">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            <GridComponent
              dataSource={data.roles}
              id="gridroles"
              enableHover
              // frozenColumns={2}
              width={!isMobile ? screenSize - 400 : 'auto'}
              allowPaging
              pageSettings={{ pageCount: 5 }}
              toolbar={toolbarOptions}
              toolbarClick={clickHandler}
              editSettings={isMobile ? editingMobile : editing}
              enableStickyHeader={!isMobile}
              allowSorting
              allowResizing
              allowExcelExport
              sortSettings={sortOptions}
              actionComplete={actionComplete}
              actionBegin={actionBegin}
              showColumnChooser
              allowTextWrap
              ref={grid}
              enableAdaptiveUI={isMobile}
              rowSelected={rowClicked}
              // dataBound={dataBound}
              rowRenderingMode={zRenderMode}
              enableAltRow
              enablePersistence
            // allowSelection
            // selectionSettings={selectionSettings}
            >
              <ColumnsDirective>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                {/* rolesGrid.map((item, index) => <ColumnDirective key={index} {...item} />)
                <ColumnDirective type="Checkbox" width={80} />
                */}
                <ColumnDirective
                  field="_id"
                  headerText="ID"
                  textAlign="Left"
                  isPrimaryKey
                  width="80"
                  visible={false}
                />
                <ColumnDirective
                  field="systemType"
                  headerText="Type"
                  textAlign="Center"
                  width="180"
                  visible
                  editTemplate={typeGrid}
                  template={typeTemplateGrid}
                />
                <ColumnDirective
                  field="name"
                  headerTemplate={gridNameHeader}
                  headerText="Name"
                  textAlign="Left"
                  width="120"
                  validationRules={valuerules}
                />
                <ColumnDirective
                  field="billing.permissions"
                  headerText="Billing"
                  textAlign="Center"
                  width="180"
                  visible
                  editTemplate={rolesBillingGridCrud}
                  // template={roleTemplateGrid}
                  headerTemplate={gridBillingHeader}
                />
                <ColumnDirective
                  field="reports.permissions"
                  headerText="Reports"
                  textAlign="Center"
                  width="180"
                  visible
                  editTemplate={rolesReportsGridCrud}
                  // template={roleTemplateGrid}
                  headerTemplate={gridReportsHeader}
                />
                <ColumnDirective
                  field="dashboard.permissions"
                  headerText="Dashboard"
                  textAlign="Center"
                  width="180"
                  visible
                  editTemplate={rolesDashboardGridCrud}
                  // template={roleTemplateGrid}
                  headerTemplate={gridDashboardHeader}
                />
                {/*
                <ColumnDirective field="billing.permissions" headerText="Billing" clipMode="EllipsisWithTooltip" headerTemplate={gridBillingHeader} textAlign="Left" width="160" editTemplate={rolesBillingGridCrud} />
                <ColumnDirective field="reports.permissions" headerTemplate={gridReportsHeader} clipMode="EllipsisWithTooltip" headerText="Reports" textAlign="Left" width="160" editTemplate={rolesReportsGridCrud} />
                <ColumnDirective field="dashboard.permissions" headerTemplate={gridDashboardHeader} clipMode="EllipsisWithTooltip" headerText="Dashboard" textAlign="Left" width="160" editTemplate={rolesDashboardGridCrud} />
                <ColumnDirective field="organizations.permissions" headerTemplate={gridOrgHeader} clipMode="EllipsisWithTooltip" headerText="Organizations" textAlign="Left" width="180" editTemplate={rolesOrganizationsGridCrud} />
                */}
                <ColumnDirective
                  field="organizations.permissions"
                  headerText="Organizations"
                  textAlign="Center"
                  width="180"
                  visible
                  editTemplate={rolesOrganizationsGridCrud}
                  // template={roleTemplateGrid}
                  headerTemplate={gridOrgHeader}
                />
                {/* }
                <ColumnDirective field="users.permissions" headerTemplate={gridUsersHeader} clipMode="EllipsisWithTooltip" headerText="Users" textAlign="Left" width="160" editTemplate={rolesUsersGridCrud} />
                <ColumnDirective field="associates.permissions" headerTemplate={gridAssociatesHeader} clipMode="EllipsisWithTooltip" headerText="Associates" textAlign="Left" width="180" editTemplate={rolesAssociatesGridCrud} />
                <ColumnDirective field="inventory.permissions" headerTemplate={gridInventoryHeader} clipMode="EllipsisWithTooltip" headerText="Inventory" textAlign="Left" width="180" editTemplate={rolesInventoryGridCrud} />
                */}
                <ColumnDirective
                  field="associates.permissions"
                  headerText="Associates"
                  textAlign="Center"
                  width="180"
                  visible
                  editTemplate={rolesAssociatesGridCrud}
                  // template={roleTemplateGrid}
                  headerTemplate={gridAssociatesHeader}
                />
                <ColumnDirective
                  field="inventory.permissions"
                  headerText="Inventory"
                  textAlign="Center"
                  width="180"
                  visible
                  editTemplate={rolesInventoryGridCrud}
                  // template={roleTemplateGrid}
                  headerTemplate={gridInventoryHeader}
                />
                <ColumnDirective
                  field="users.permissions"
                  headerText="Users"
                  textAlign="Center"
                  width="180"
                  visible
                  editTemplate={rolesUsersGridCrud}
                  // template={roleTemplateGrid}
                  headerTemplate={gridUsersHeader}
                />
                <ColumnDirective
                  field="alerts.permissions"
                  headerText="Alerts"
                  textAlign="Center"
                  width="180"
                  visible
                  editTemplate={rolesAlertsGridCrud}
                  // template={roleTemplateGrid}
                  headerTemplate={gridAlertsHeader}
                />
                <ColumnDirective
                  field="calendar.permissions"
                  headerText="Calendar/Apps"
                  textAlign="Center"
                  width="180"
                  visible
                  editTemplate={rolesCalendarGridCrud}
                  // template={roleTemplateGrid}
                  headerTemplate={gridCalendarHeader}
                />
                <ColumnDirective
                  field="notifications.permissions"
                  headerText="Notifications"
                  textAlign="Center"
                  width="180"
                  visible
                  editTemplate={rolesNotificationsGridCrud}
                  // template={roleTemplateGrid}
                  headerTemplate={gridNotificationsHeader}
                />
                <ColumnDirective
                  field="roles.permissions"
                  headerText="Roles"
                  textAlign="Center"
                  width="180"
                  visible
                  editTemplate={rolesRolesGridCrud}
                  // template={roleTemplateGrid}
                  headerTemplate={gridRolesHeader}
                />

                {/* }
                <ColumnDirective field="alerts.permissions" headerTemplate={gridAlertsHeader} clipMode="EllipsisWithTooltip" headerText="Alerts" textAlign="Left" width="160" editTemplate={rolesAlertsGridCrud} />
                <ColumnDirective field="calendar.permissions" headerTemplate={gridCalendarHeader} clipMode="EllipsisWithTooltip" headerText="Calendar" textAlign="Left" width="160" editTemplate={rolesCalendarGridCrud} />
                <ColumnDirective field="notifications.permissions" headerTemplate={gridNotificationsHeader} clipMode="EllipsisWithTooltip" headerText="Notifications" textAlign="Left" width="150" editTemplate={rolesNotificationsGridCrud} />
                <ColumnDirective field="roles.permissions" headerTemplate={gridRolesHeader} headerText="Roles" clipMode="EllipsisWithTooltip" textAlign="Left" width="160" editTemplate={rolesRolesGridCrud} />
                    */}
              </ColumnsDirective>
              <Inject services={[Search, Page, Selection, Toolbar, Edit, Sort, Filter, ColumnChooser, ExcelExport, Resize, ForeignKey, Freeze]} />
            </GridComponent>
          </div>
        </div>
      </div>
      <DialogComponent ref={dialogRef} header="No Row Selected" content="No records selected for clone operation" showCloseIcon width="300px" buttons={dialogButtons} visible={false} />
    </div>
  );
};

export default Roles;
